import { PageRef } from 'providers/page-ref';

export type DbRestoreJsonPageParams = {};

export const IDbRestoreJsonPage: PageRef<DbRestoreJsonPageParams, void> = {
  pageName: 'DbRestoreJsonPage',
} as PageRef<DbRestoreJsonPageParams, void>;
